import { useEffect, useRef } from 'react';

interface IProps {
	className?: string;
	html: string;
}

export const ShadowHtml = ({ className, html }: IProps) => {
	const hostRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const host = hostRef.current;
		if (!host) {
			return;
		}
		const shadowRoot = host.shadowRoot ?? host.attachShadow({ mode: 'open' });
		shadowRoot.innerHTML = html;
	}, [html]);

	return <div className={className} ref={hostRef} />;
};
